module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-modal', {
    attrs: {
      "content-classes": "filter-location-modal"
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('big', {
    staticClass: "exit text-grey absolute-top-right cursor-pointer",
    on: {
      "click": function($event) {
        _vm.$children[0].close()
      }
    }
  }, [_c('i', [_vm._v("clear")])]), _vm._v(" "), _c('big', {
    staticClass: "title text-primary text-bold"
  }, [_vm._v("LOCATION")]), _vm._v(" "), _c('div', {
    staticClass: "selection-row row wrap gutter"
  }, _vm._l((_vm.planningAreas), function(region) {
    return _c('div', {
      staticClass: "select-group sm-width-1of2 md-width-1of3 bg-width-1of3 lg-width-1of5"
    }, [_c('p', {
      staticClass: "text-secondary text-bold"
    }, [_vm._v(_vm._s(region.label))]), _vm._v(" "), _c('div', {
      staticClass: "select-all"
    }, [_c('label', {
      staticClass: "text-primary"
    }, [_c('q-checkbox', {
      staticClass: "text-primary text-bold",
      attrs: {
        "value": _vm.checked(region)
      },
      on: {
        "input": function($event) {
          _vm.select(region, $event)
        }
      }
    }), _vm._v("\n          Select All\n        ")], 1)]), _vm._v(" "), _c('div', {
      staticClass: "select-one column"
    }, _vm._l((region.areas), function(area) {
      return _c('label', {
        staticClass: "text-primary"
      }, [_c('q-checkbox', {
        attrs: {
          "value": _vm.checked(area)
        },
        on: {
          "input": function($event) {
            _vm.select(area, $event)
          }
        }
      }), _vm._v("\n          " + _vm._s(area.label) + "\n        ")], 1)
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('button', {
    staticClass: "exit-done primary float-right text-bold",
    on: {
      "click": function($event) {
        _vm.$children[0].close()
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('button', {
    staticClass: "exit-reset primary float-right text-bold",
    on: {
      "click": function($event) {
        _vm.resetAll()
      }
    }
  }, [_vm._v("Reset")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-40c13831", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40c13831!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterView/Modal/Location.vue
// module id = 850
// module chunks = 0